import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DataSource } from 'angular2-smart-table/lib/lib/data-source/data-source';
import { map } from 'rxjs/operators';

import { UsersApi } from '../api/users.api';
import { UserData, User } from '../../../interfaces/common/users';
import { ROLES } from '../../../../auth/roles';

@Injectable()
export class UsersService extends UserData {

  constructor(
    private api: UsersApi,
    private translate: TranslateService
  ) {
    super();
  }

  get gridDataSource(): DataSource {
    return this.api.usersDataSource;
  }

  list(pageNumber: number = 1, pageSize: number = 10): Observable<User[]> {
    return this.api.list(pageNumber, pageSize);
  }

  getCurrentUser(): Observable<User> {
    return this.api.getCurrent()
      .pipe(
        map(u => {
          if (u && !u.setting) {
            u.setting = {};
          }

          if (u & u.hasOwnProperty('locale')) {
            this.translate.use(u.locale);
          }

          return u;
        }));
  }

  getCurrentWithInfo(): Observable<any> {
    return this.api.getCurrentwithInfo()
      .pipe(
        map(u => {
          if (u && !u.setting) {
            u.setting = {};
          }

          return u;
        }));
  }

  currentUserIsAdmin(): Observable<boolean> {
    return this.api.getCurrent()
      .pipe(
        map(u => {
          return u.role === ROLES.ADMIN;
        }));
  }

  get(id: number): Observable<User> {
    return this.api.get(id);
  }

  create(user: any): Observable<User> {
    return this.api.add(user);
  }

  update(user: any): Observable<User> {
    return this.api.update(user);
  }

  updateCurrent(user: any): Observable<User> {
    return this.api.updateCurrent(user);
  }

  resetPassword(request: any): Observable<User> {
    return this.api.resetPassword(request);
  }

  delete(id: number): Observable<boolean> {
    return this.api.delete(id);
  }

  verifyOtp(payload): Observable<any> {
    return this.api.verifyOtp(payload);
  }

  resendOtp(payload): Observable<any> {
    return this.api.resendOtp(payload);
  }

  login(user): Observable<any>{
    return this.api.login(user);
  }
  
  resetCookie(): Observable<any>{
    return this.api.resetCookie();
  }

  // isCookieValid(): Observable<any> {
  //   return this.api.isCookieValid();
  // }
}
